class Permissions {
  constructor(params) {
    this.permissions = params;

    this.mayReadInsuranceRight = this.hasPermissionFor('r-insurance-right');
    this.mayCreateInsuranceRight = this.hasPermissionFor('c-insurance-right');
    this.mayReadInsurance = this.hasPermissionFor('r-ins');
    this.mayReadInvoice = this.hasPermissionFor('r-inv');
    this.mayCreatePaymentArrangement = this.hasPermissionFor('c-pay-arr');
    this.mayReadPremium = this.hasPermissionFor('r-pre');
    this.mayReadExcess = this.hasPermissionFor('r-exc');
    this.mayUpdateInsurance = this.hasPermissionFor('u-ins');
    this.mayReadPolicyDocument = this.hasPermissionFor('r-pol-doc');
    this.mayCreateInsuredPerson = this.hasPermissionFor('c-ins-per');
    this.mayCompensationDocument = this.hasPermissionFor('r-com-doc');
    this.mayReadPersonalDetails = this.hasPermissionFor('r-per-det');
    this.mayUpdatePersonalDetails = this.hasPermissionFor('u-per-det');
    this.mayReadPaymentDetails = this.hasPermissionFor('r-pay-det');
    this.mayUpdatePaymentDetails = this.hasPermissionFor('u-pay-det');
    this.mayReadMessages = this.hasPermissionFor('r-msg');
    this.mayCreateDeclaration = this.hasPermissionFor('c-dec');
    this.mayCreateEHIC = this.hasPermissionFor('c-ehic');
    this.mayReadDeclaration = this.hasPermissionFor('r-dec');
    this.mayReadContact = this.hasPermissionFor('r-con');
    this.mayCreateContact = this.hasPermissionFor('c-con');
    this.mayReadAccount = this.hasPermissionFor('r-acc');
    this.mayUpdateAccount = this.hasPermissionFor('u-acc');
    this.mayUpdatePassword = this.hasPermissionFor('u-pw');
    this.mayLogin = this.hasPermissionFor('login');
    this.mayReadMemberOffer = this.hasPermissionFor('r-mem-off');
    this.mayCreateMemberOfferTip = this.hasPermissionFor('c-mem-off-tip');
    this.isAdmin = this.hasPermissionFor('admin');
    this.mayCreateCareMediation = this.hasPermissionFor('c-care-med');
    this.mayCreateTreatmentAbroad = this.hasPermissionFor('c-treat-abr');
  }

  hasPermissionFor(permission) {
    return this.permissions.includes(permission);
  }
}
export { Permissions as default };
